import React, { useEffect, useState } from "react";
import "./coral-commenting.m.css";
import DOMPurify from "dompurify";
import useStorage from "../../../hook/useStorage";
import BookmarkPopup from "../../molecules/bookmark-popup";
import { updateUserFlag } from "../../../hook/update-user-flag";
import { deleteUserFlag } from "../../../hook/delete-user-flag";
import useUrl from "../../../hook/useUrl";
import LoginFormBase from "../login-forms/login-form";
import { getUserData } from "../../utils/getUserData";
import { createUrl } from "../../utils/createurl";

const CoralCommenting = (story) => {
  const storyId = story.story.id;
  const [startCommenting, setStartCommenting] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [checkUser] = useStorage();
  const [commentUserFlag, setCommentUserFlag] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [, currentUrlSlug] = useUrl();
  const [storyUrl, setStoryUrl] = useState("");
  const [existingNickName, setExistingNickName] = useState("");
  const [newNickName, setNewNickName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [tokenRerender, setTokenRerender] = useState(false);
  //  const [showLoginPopupLoggedin, setShowLoginPopupLoggedin] = useState(false);
  const usrname = getUserData();
  const commentRuleLink = story && story.story && story.story.url && story.story.url.includes("fiare.qtstage.io") ? "https://aspastating.wpengine.com/keskusteluohje" : "https://ilkkapohjalainen.fi/keskusteluohje";
  const linksAccount = createUrl("createaccount");
  const coralUrl = story && story.story && story.story.url && story.story.url.includes("fiare.qtstage.io") ? "https://coraldev.fluentia.fi" : "https://keskustelu.ilkkapohjalainen.fi";

  const createdAt = story && story.story && story.story["published-at"] || "";

//TODO: remove console.logs and change date to release date
  useEffect(() => {
    if (typeof window !== "undefined") {
      //Set url for stories created after given date.
      //This way we don't lose comments that are created
      //before but can avoid having "Not available" titles in Coral control panel in newer stories.
      const storyCreated = new Date(createdAt);
      const comparisonDate = new Date('2025-01-09');
            if (storyCreated >= comparisonDate) {
              let storyUrl = window.location.href;
              if (storyUrl.includes("localhost:3000")) {
                storyUrl = storyUrl.replace("localhost:3000", "imediat-web.fiare.qtstage.io");
              }
              setStoryUrl(storyUrl);
      //console.log('The date is after 2025-01-09');
  }
  else {
      //Set url for stories created before given date.
      //"Not available" titles in Coral control panel are possible for these stories.
      const hostName = window.location.hostname;
      const path = window.location.pathname;
      const getStoryUrl = (hostName, path, currentUrlSlug) => {
        if ((hostName === "localhost" || hostName.includes("imediat-web.fiare.qtstage"))) {
          return `https://imediat-web.fiare.qtstage.io${path}`;
        } else if (hostName.includes("yhteissivusto.fiare.qtstage")) {
          return `https://yhteissivusto.fiare.qtstage.io${path}`;
        } else {
          if (currentUrlSlug === "epari" || currentUrlSlug === "vaasalehti") {
            return `https://ilkkapohjalainen.fi${path}`;
          }
          else {
            return story.story.url;
          }
        }
      };

      //console.log('The date is not after 2025-01-09');
      const storyModificatedUrl = getStoryUrl(hostName, path, currentUrlSlug);
      setStoryUrl(storyModificatedUrl);
  }
}

    //console.log(storyUrl, "storyUrl ");
  }, [currentUrlSlug, story.story.url]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const userCommentFlag = async () => {
      if (typeof window === 'undefined') {
        return;
      } else {
        try {
          const response = await fetch(`/profile/flag/getByName`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ flag_name: "has_enabled_comments" }),
          });
          const jsonResponse = response && await response.json();
          if (jsonResponse.data == "1") {
            setCommentUserFlag(true);
            fetchAccessTokenAndInitCoral(true)
            // deleteUserFlag("comments_user_flag")
          } else {
            setCommentUserFlag(false);
            fetchAccessTokenAndInitCoral(false)
          }
        } catch (error) {
          fetchAccessTokenAndInitCoral(false);
        }
      }
    };

    const fetchAccessTokenAndInitCoral = async (usrFlag) => {
      try {
        const response = await fetch("/coral-sso/getJwtToken");
        const tokenObj = response.ok && await response.json();
        const script = document.createElement('script');
        script.src = `${coralUrl}/assets/js/embed.js`;
        script.async = false;
        script.defer = true;
        script.onload = async () => {
          const coralConfig = {
            id: "coral_thread",
            autoRender: true,
            rootURL: `${coralUrl}`,
            storyID: storyId,
            storyURL: storyUrl,
            customCSSURL: '/coral-styles.css',
            customFontsCSSURL: '/coral-fonts.css',
            events: function (events) {
              events.onAny(function (eventName, data) {

                if (eventName === "createComment.success" || eventName === "createComment.error" ||
                  eventName === "createCommentReaction.success" || eventName === "createCommentReaction.error" ||
                  eventName === "createCommentReply.success" || eventName === "createCommentReply.error" ||
                  eventName === "loadMoreAllComments.success" || eventName === "loadMoreAllComments.error" ||
                  eventName === "reportComment.success" || eventName === "reportComment.error"
                ) {
                  window.dataLayer.push({
                    coralEvent : eventName, data
                  })
                }


                if (eventName === "showAuthPopup") {
                  if (window !== "undefined") {
                    window.open = function (url, name, specs) {
                      return null;
                    }
                  }
                  if (data.view === "SIGN_IN") {
                    setShowLoginPopup(true);
                  }
                }
              });
            },
          };
          if (checkUser && !tokenObj.tokenOK) {
            const syncFetchCall=await fetch("/tulo/ajax/SyncProfileInfo");
            const callResponse = await syncFetchCall.json();
            if(callResponse.success){
              setTokenRerender(true)
            }
          }
          if (tokenObj.tokenOK && usrFlag) {
            coralConfig.accessToken = tokenObj.token;
            coralConfig.containerClassName = "commentcontainer-loggedin"
          } else {
            coralConfig.accessToken = null;
            coralConfig.containerClassName = "commentcontainer-loggedout"
          }
          window.Coral.createStreamEmbed(coralConfig);
        };
        (document.body || document.head).appendChild(script);
        return () => {
          (document.body || document.head).removeChild(script);
        };
      } catch (error) {
        console.error('Failed to fetch the access token:', error);
      }
    };

    const timeoutId = setTimeout(() => {
      userCommentFlag();
    }, 700);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [storyId, storyUrl, commentUserFlag, checkUser,tokenRerender]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    } else {
      //const nickName = window.localStorage.getItem("nickname")
      //const username = usrname.username;
      //const validNickName = username !=="undefined" ? username : "";
      //setExistingNickName( validNickName )
      //setNewNickName( validNickName )
    }
    const timer = setTimeout(() => {
      setIsDisplayed(true);
    }, !checkUser ? 1000 : 0);

    return () => clearTimeout(timer);
  }, [checkUser]);

  // input validation can be done as needed, for now it should accept only alphanumeric max. 25 chars with max 2 spaces.
  const validateNickname = (nickname) => {
    // Validate max length of 25 characters
    if (nickname.length > 25) {
      return "Nimimerkki voi olla enintään 25 merkkiä pitkä. Ole hyvä ja yritä uudelleen!";
    }
    // Validate min length of 2 characters
    if (nickname.length < 3) {
      return "Nimimerkin tulee olla vähintään 3 merkkiä pitkä. Ole hyvä ja yritä uudelleen!";
    }

    // Validate maximum 2 spaces
    const spaceCount = (nickname.split(' ').length - 1);
    if (spaceCount > 2) {
      return "Nimimerkki voi sisältää enintään kaksi välilyöntiä. Ole hyvä ja yritä uudelleen!";
    }

    // Validate alphanumeric characters (including Scandinavian) and spaces only
    const validPattern = /^[a-zA-Z0-9ÅÄÖåäöØøÆæ ]+$/u;
    if (!validPattern.test(nickname)) {
      return `Nimimerkki voi sisältää vain kirjaimia ja numeroita. Ole hyvä ja yritä uudelleen!`;
    }
    return "";
  };

  const handleSaveNick = async () => {
    const validationError = validateNickname(newNickName);
    if (validationError) {
      setErrorMessage(validationError);
      setCommentUserFlag(false)

    } else {
      //updateUserFlag("comments_user_flag")
      //setCommentUserFlag(true)
      try {
        setErrorMessage("");
        setIsSaving(true);
        const response = await fetch("/tulo-user/nick/update", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ nick: newNickName }),
        });
        const checkResponse = await response.json()
        if (checkResponse.api_update_status === "0" && checkResponse.errors && checkResponse.errors.length > 0) {
          const firstError = checkResponse.errors[0].message;
          const message = firstError === "alias already exists" ? "Antamasi nimimerkki on jo toisen tilin käytössä. Ole hyvä ja yritä uudelleen!" : firstError;
          setErrorMessage(message);
          setCommentUserFlag(false)
        } else if (checkResponse.api_update_status === "1") {
          await updateUserFlag("comments_user_flag")
          setCommentUserFlag(true)
          setExistingNickName(newNickName);
          if (typeof window !== 'undefined') {
            window.location.reload(true);
          }

        } else {
          setErrorMessage("Nimimerkin tallentaminen epäonnistui. Ole hyvä ja yritä uudelleen!");
          // setCommentUserFlag(false)
        }
      } catch (error) {
        setErrorMessage("Nimimerkin tallentaminen epäonnistui.");
        console.error("Error saving nickname:", error);
      } finally {
        setIsSaving(false);
      }
    }
  };

  return (
    <div id="coral-top-container" styleName="coral-top-container" className="coral-top-container voice-no-read">
      <div className="speech-bottom" styleName="speech-bottom">
        <h1>Mitä ajatuksia juttu herätti? Kerro näkemyksesi, pohdiskele, kommentoi!</h1>
        Voit osallistua keskusteluun omalla nimellä tai nimimerkillä.
      </div>
      <div styleName="header-container"><h2 styleName="comment-header">Keskustele
        {' ('}
        <span
          className="coral-count"
          data-coral-id={storyId}
          data-coral-notext="true">
          <span class="coral-count-number">0</span> {/* Class is needed for fetching from coral */}
        </span>
        {')'}
      </h2>
        <button styleName="open-comment-rules-btn" onClick={() => setShowRules(!showRules)}>Säännöt</button></div>
      {<>
        {/*(checkUser && commentUserFlag === true) && <p styleName="coral-login-text">Jos et näe kommentteja tai kommentointikenttää, ole hyvä ja kirjaudu ulos ja uudelleen sisään.</p>*/}
        {(showRules && !startCommenting || showRules && commentUserFlag === true) &&
          <div styleName="comment-rules">
            <p>Ilkka-Pohjalaisen toimitus tarkastaa jokaisen kommentin ennen julkaisua. Mieti kommenttisi sisältöä ja kirjoita toisia kunnioittavasti, sillä emme julkaise halventavia, rasistisia tai muuten loukkaavia sisältöjä. Kirosanoja, linkkejä tai mainoksia sisältäviä kommentteja ei myöskään julkaista.</p><br />
            <p>Kommentin tulee liittyä artikkelin aiheeseen. Ilkka-Pohjalainen voi käyttää keskustelijoiden kommentteja sellaisenaan tai apuna uusien sisältöjen kehittämisessä. Parhaimmillaan lukijoiden keskustelu monipuolistaa ja vie aihetta eteenpäin, ei junnaa paikallaan tai syytä tai halvenna muita keskustelijoita.</p> <br />
            <p>Luethan myös laajemmat <a href={commentRuleLink} target="_blank" styleName="comment-rule-link">keskusteluohjeet</a> ennen keskusteluun osallistumista.</p> <br />            <p>Keskustellaksesi sinulla tulee olla I-Mediatili.</p>
          </div>}
        {isDisplayed && !checkUser && <>
          <p styleName="coral-login-text">Osallistu keskusteluun kirjautumalla sisään tai luomalla maksuton <a styleName="commenting-create-account-link" href={linksAccount}>I-Mediatili</a>.</p>
          {!showLoginForm && <button styleName="comment-login" className="comment-login" onClick={() => setShowLoginForm(true)}>Kirjaudu</button>}
        </>}
        {!checkUser && showLoginForm && <LoginFormBase />}
        {isDisplayed && checkUser && !commentUserFlag && (!startCommenting) && <button styleName="comment-activate" className="comment-activate" onClick={() => setStartCommenting(true)}>Aloita keskustelu</button>}
        {(startCommenting && !commentUserFlag) &&
          <div>
            <h3 styleName="coral-h3-header">Lue säännöt</h3>
            <p>Ilkka-Pohjalaisen toimitus tarkastaa jokaisen kommentin ennen julkaisua. Mieti kommenttisi sisältöä ja kirjoita toisia kunnioittavasti, sillä emme julkaise halventavia, rasistisia tai muuten loukkaavia sisältöjä. Kirosanoja, linkkejä tai mainoksia sisältäviä kommentteja ei myöskään julkaista.</p><br />
            <p>Kommentin tulee liittyä artikkelin aiheeseen. Ilkka-Pohjalainen voi käyttää keskustelijoiden kommentteja sellaisenaan tai apuna uusien sisältöjen kehittämisessä. Parhaimmillaan lukijoiden keskustelu monipuolistaa ja vie aihetta eteenpäin, ei junnaa paikallaan tai syytä tai halvenna muita keskustelijoita.</p><br />
            <p>Luethan myös laajemmat <a href={commentRuleLink} target="_blank" styleName="comment-rule-link">keskusteluohjeet</a> ennen keskusteluun osallistumista.</p> <br />
            <div styleName="set-nickname-container">
              <h3 styleName="coral-h3-header">Kirjoita nimi tai nimimerkki</h3>
              <p>Suosittelemme käyttämään keskustelussa omaa nimeäsi, mutta voit keksiä itsellesi myös nimimerkin.</p><br />
              {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
              <input
                type="text"
                placeholder={"Nimi tai nimimerkki"}
                styleName="set-nickname-input"
                aria-label="Kirjoita nimi tai nimimerkki tähän"
                onChange={(e) => {
                  const nameValue = e.target.value
                  const nickname = DOMPurify.sanitize(nameValue);
                  setNewNickName(nickname)
                }}
                disabled={isSaving}
              />
            </div>
            <div styleName="start-commenting-buttons" className="start-commenting-buttons">
              <button styleName="comment-cancel" className="comment-cancel" onClick={() => {
                setStartCommenting(false);
                setErrorMessage(''); // Reset the error message
              }}>Peruuta</button>
              <button styleName="comment-save" className="comment-save" onClick={() => {
                handleSaveNick()
              }}>Tallenna ja hyväksy</button>
            </div>
          </div>}
      </>}
      <div styleName="coral-thread-container">
        <div id="coral_thread" className="coral-thread"></div>
      </div>
      {(showLoginPopup && isDisplayed && !checkUser) ? <BookmarkPopup closePopup={() => setShowLoginPopup(false)} feature={"commenting"} /> : ""}
      {(showLoginPopup && isDisplayed && checkUser && !commentUserFlag) ? <BookmarkPopup closePopup={() => setShowLoginPopup(false)} feature={"commenting-loggedin"} /> : ""}
    </div>
  );
};
export { CoralCommenting };
